module.exports = __webpack_public_path__ + "static/media/night05.d416c985.jpeg";